import styled from "@emotion/styled";
export const DatePickerTextInputWrap = styled("div")`
    position: relative;

    // Ensure the stacking context we create in children of this
    // component doesn't override others by default.
    isolation: isolate;
`;
//# sourceMappingURL=DatePickerTextInputWrap.js.map